import React from 'react';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';

import { useResponsive } from '../hooks/useResponsive';

export const CheckboxLayer = ({
  id,
  value,
  label,
  color,
  handleLayer,
  explain,
  type = 'line',
}) => {
  const { isDesktop } = useResponsive();
  const [open, setOpen] = React.useState(false);

  const style = {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    checkboxContainer: {
      display: 'flex',
      minWidth: isDesktop ? '15em' : '10em',
      width: isDesktop ? 'max-content' : '100%',
      maxWidth: '20em',
    },
    formControl: {
      display: 'flex',
      minWidth: isDesktop ? '5em' : '3em',
      width: isDesktop ? '20em' : '70%',
    },
    colorLegendContainer: {
      display: 'flex',
      width: 100,
      height: type === 'point' ? '1em' : '.5em',
      alignSelf: 'center',
    },
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={style.container}>
      <Box sx={style.checkboxContainer}>
        <FormControlLabel
          sx={style.formControl}
          value={id}
          control={
            <Checkbox
              checked={value}
              onChange={(evt) => handleLayer(evt.target.value)}
            />
          }
          label={label}
          labelPlacement='end'
        />
        <Tooltip
          open={open}
          arrow
          title={
            <Typography fontSize={isDesktop ? null : '1.4em'}>
              {explain}
            </Typography>
          }
          placement='bottom'
          onClose={handleClose}
        >
          <IconButton size='small' onClick={handleOpen}>
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Box sx={style.colorLegendContainer}>
        <Box
          sx={{
            backgroundColor: color,
            width: type === 'point' ? '1em' : '100%',
            borderRadius: '1em',
          }}
        />
      </Box>
    </Box>
  );
};
